const ArtworkTariff = `
  id
  code
  description
`;

export default ArtworkTariff;
